import { render } from "./FloatingContent.vue?vue&type=template&id=c86fea12"
import script from "./FloatingContent.vue?vue&type=script&lang=js"
export * from "./FloatingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__